import React from "react";

const SafeImage = ({
  src,
  fallback,
  alt,
  noImage = "/media/shape/noimage.png",
  ...props // 👈 all HTML attributes support
}) => {
  const handleError = (e) => {
    const current = e.currentTarget;
    const noImg = typeof noImage === "string" ? noImage : "";

    if (!current.dataset.fallback) {
      current.dataset.fallback = "1";

      if (fallback && current.src !== fallback) {
        current.src = fallback;
      } else {
        current.src = noImg;
      }
    } else {
      current.src = noImg;
    }
  };

  return (
    <img
      src={src || fallback || noImage}
      alt={alt}
      onError={handleError}
      {...props}
    />
  );
};

export default SafeImage;